import {
    LoginTypes
} from 'actions/types';
import axios from 'axios';

export function login(username, password) {
    return (dispatch, getState) => {
        try {
            var currentLoginIndex = getState().config.get('currentLoginIndex');
            var route = getState().urls.getIn(['loginUrls', currentLoginIndex]);
            var headers = getState().config.get('headers').toJSON();
            var url = route.get('href');
            var method = route.get('method');
            var codeChallenge = getState().security.get('codeChallenge');
            var params = Object.assign({
                username,
                password,
                codeChallenge
            })

        } catch(error) {
            dispatch(loginError(error))
            throw error
        }

        dispatch({
            type: LoginTypes.LOGIN,
            payload: params
        })

        return axios({ method, url, headers, data: params })
        .then(({ data }) => {
            dispatch(loginSuccess(data))
            return data
        })
        .catch(error => {
            const { status, data } = error.response || {};
            const normalized = {
                code: data?.code || status || error.code || 'UNKNOWN_ERROR',
                message: data?.message || error.message
            }
            dispatch(loginError(normalized))
            throw normalized
        })
    }
}

export function loginSuccess(response) {
    return (dispatch, getState) => {
        dispatch({
            type: LoginTypes.LOGIN_SUCCESS,
            payload: response
        })
    }
}

export function loginError(error) {
    return {
        type: LoginTypes.LOGIN_ERROR,
        payload: error
    }
}

export function logout() {
    return (dispatch, getState) => {
        dispatch({
            type: LoginTypes.LOGOUT
        })
    }
}